import { Flex, Heading, Stack, useColorModeValue } from '@chakra-ui/react'
import ForgotPasswordForm from '../../components/forms/auth/ForgotPasswordForm';

export default function ForgotPassword() {
    return (
        <Flex
            minH={'100vh'}
            align={'center'}
            justify={'center'}
            bg={useColorModeValue('gray.50', 'gray.800')}
        >
            <Stack spacing={8} mx={'auto'} maxW={'xl'} py={12} px={6}>
                <Stack align={'center'}>
                    <Heading fontSize={'4xl'}>パスワードをお忘れですか？</Heading>
                </Stack>
                <ForgotPasswordForm />
            </Stack>
        </Flex>
    )
}
